import firebase from 'firebase';
import { eventBus } from '../main';

export default {
    data: function() {
        var user = firebase.auth().currentUser;
        if (user) {
            eventBus.$emit('loggedIn', true);
            return user;
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/uid.js